"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const video_preloader_1 = __importDefault(require("../utils/video-preloader"));
var LoadingState;
(function (LoadingState) {
    LoadingState[LoadingState["NONE"] = -1] = "NONE";
    LoadingState[LoadingState["LOADING"] = 0] = "LOADING";
    LoadingState[LoadingState["CACHED"] = 1] = "CACHED";
})(LoadingState || (LoadingState = {}));
class SlidesManager {
    constructor(presentationId) {
        this.cachedMedia = {};
        this.loadingState = {};
        this.presentationId = presentationId;
        this.slides = [];
        this.currentIndex = 0;
    }
    getState(index) {
        let currSlide = this.slides[index];
        if (currSlide === undefined)
            return null;
        let url = currSlide.url;
        if (this.loadingState[url]) {
            return this.loadingState[url];
        }
        return null;
    }
    // gets from cache or returns the url of the current index
    get(index, preloaderCallback) {
        let currSlide = this.slides[index];
        return new Promise((resolve, reject) => {
            if (currSlide === undefined)
                reject();
            var baseURL = window.location.origin;
            if (this.cachedMedia[currSlide.url]) {
                currSlide.url = this.cachedMedia[currSlide.url];
                resolve(currSlide);
            }
            return (0, video_preloader_1.default)(new URL(currSlide.url, baseURL), preloaderCallback)
                .then((blob) => {
                let url = URL.createObjectURL(blob);
                currSlide.url = url;
                this.cachedMedia[currSlide.url] = url;
                resolve(currSlide);
            });
        });
    }
    updateCurrentIndex(currentIndex) {
        this.currentIndex = currentIndex;
        // Preload closer slides and set cache
        for (let i = 0; i < this.slides.length; i++) {
            if ((i - this.currentIndex) <= 4 && (i - this.currentIndex) >= 0) {
                let slide = this.slides[i];
                if (!this.cachedMedia[slide.url]) {
                    if (this.loadingState[slide.url] === LoadingState.NONE || this.loadingState[slide.url] === undefined) { // If its not cached and not loading
                        this.loadingState[slide.url] = LoadingState.LOADING;
                        this.downloadVideo(slide.url, i);
                    }
                }
            }
        }
    }
    loadSlides() {
        return new Promise((resolve, reject) => {
            let url = '/presentation/' + this.presentationId + '/slides';
            fetch(url)
                .then(response => {
                return response.json();
            })
                .then(data => {
                let unordered_slides = [];
                data.forEach((x) => {
                    let slide = {
                        media_id: x.medium.id,
                        media_type: x.medium.media_type,
                        order: x.order,
                        posInEditor: x.order,
                        url: x.medium.url,
                        name: x.name
                    };
                    unordered_slides.push(slide);
                });
                this.slides = unordered_slides.sort((a, b) => (a.order > b.order) ? 1 : -1);
                this.updateCurrentIndex(0);
                resolve(this.slides);
            }).catch(response => {
                reject(response);
            });
        });
    }
    downloadVideo(url, index, preload = true) {
        var req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.responseType = 'blob';
        req.onload = () => {
            // Onload is triggered even on 404
            // so we need to check the status code
            if (req.status === 200) {
                var videoBlob = req.response;
                var vid = URL.createObjectURL(videoBlob); // IE10+
                // Video is now downloaded
                // and we can set it as source on the video element
                if (preload) {
                    this.cachedMedia[url] = vid;
                    // if(index === this.currentIndex)
                    // this.mediaInDisplay = index;
                }
                else {
                    // this.mediaInDisplay = vid;
                }
            }
        };
        req.onerror = function () {
            // Error
        };
        req.send();
    }
}
exports.default = SlidesManager;
